// src/hooks/useSecureMedia.js (نسخه نهایی و کامل)

import { useState, useCallback } from 'react';
import axiosInstance from '../utils/axiosInstance'; 
import { useAuthContext } from '../context/AuthContext';
// 🟢 ۱. ایمپورت هوک تاریخچه
import useHistoryTracking from './useHistoryTracking'; 


const useSecureMedia = (mediaId) => {
  
  const { openAuthModal } = useAuthContext(); 
  
  // 🛑 FIX VITAL: تعاریف وضعیت حذف شده اضافه شدند
  const [streamUrl, setStreamUrl] = useState(null); 
  const [currentMedia, setCurrentMedia] = useState(null);    // 🟢 اضافه شد
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);  // 🟢 اضافه شد
  const [fetching, setFetching] = useState(false);          // 🟢 اضافه شد
  
  const [initialTime, setInitialTime] = useState(0); 
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // 🟢 ۳. فراخوانی هوک تاریخچه (فقط برای گرفتن تابع واکشی موقعیت)
  const { getInitialPlaybackPosition } = useHistoryTracking(mediaId);


  // ----------------------------------------------------
  // ۱. تابع واکشی URL امن (اصلاح شده)
  // ----------------------------------------------------
  const fetchSecuredUrl = useCallback(async (id) => {
    const endpoint = `/products/protected-url/${id}/`;

    if (!id) {
        setStreamUrl(null); 
        setInitialTime(0);
        return;
    }

    setIsLoading(true);
    setError(null);

    try {
      setFetching(true); // ✅ استفاده صحیح از fetching
      const response = await axiosInstance.get(endpoint);
      
      let url;
      if (response.data && response.data.presigned_url) {
          url = response.data.presigned_url;
      } else if (response.data && response.data.media_url) {
          url = MEDIA_BASE_URL + response.data.media_url;
      } else {
           throw new Error("پاسخ سرور فاقد URL بود.");
      }
      
      // 🟢 ۴. واکشی موقعیت پخش قبلی
      const savedTime = await getInitialPlaybackPosition();
      
      setStreamUrl(url); 
      setInitialTime(savedTime); 
      
      return { url, initialTime: savedTime }; 

    } catch (err) {
      console.error("Error fetching secured URL:", err);
      
      if (err.response && err.response.status === 401) {
          alert("برای پخش محتوا، ابتدا وارد شوید.");
          openAuthModal(); 
      } else {
          alert("خطا در برقراری ارتباط. اتصال خود را بررسی کنید.");
      }
      
      setInitialTime(0); 
      return null;

    } finally {
        setFetching(false);
        setIsLoading(false); // ✅ این خط هم باید در اینجا اجرا شود
    }
  }, [openAuthModal, getInitialPlaybackPosition]); 


  // ----------------------------------------------------
  // ۲. تابع اصلی برای شروع جریان پخش (Start Playback)
  // ----------------------------------------------------
  const startPlayback = useCallback(async (mediaItem) => {
    if (!mediaItem || !mediaItem.id) return;
    
    const result = await fetchSecuredUrl(mediaItem.id);

    if (result && result.url) {
      setCurrentMedia(mediaItem); // 🟢 اکنون تعریف شده است
      setStreamUrl(result.url);
      setIsPlayerOpen(true); // 🟢 اکنون تعریف شده است
      // 💡 در اینجا باید پلیر اصلی شما با استفاده از result.initialTime شروع کند.
    }
  }, [fetchSecuredUrl]);
  
  // ----------------------------------------------------
  // ۳. توابع کنترلی و خروجی
  // ----------------------------------------------------
  const closePlayer = useCallback(() => {
    setIsPlayerOpen(false); // 🟢 اکنون تعریف شده است
    setCurrentMedia(null); // 🟢 اکنون تعریف شده است
    setStreamUrl(null); 
  }, []);
  
  return {
    streamUrl,
    initialTime, 
    currentMedia,
    isPlayerOpen, // 🟢 اکنون تعریف شده است
    startPlayback,
    closePlayer,
    fetching,
    fetchSecuredUrl 
  };
};

export default useSecureMedia;